// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.uppy-Dashboard-poweredBy {\r\n    display: none;\r\n}\r\n.uppy-Dashboard-inner {\r\n    width: 100%!important;\r\n    height: 150px!important;\r\n}", ""]);
// Exports
module.exports = exports;
